/* eslint-disable prettier/prettier */
/* eslint-disable no-var */
/* ignore style issues on this 3rd party file for future compare purposes */

import TurndownService from "turndown"
import { gfm } from "turndown-plugin-gfm"

export default function markdownService() {
  function padLeft(str, pad) {
    return (pad + str).slice(-pad.length)
  }

  // function padRight(str, pad) {
  //   return (str + pad).substring(0, pad.length)
  // }

  function fill(size, char) {
    if (typeof size != "number") {
      size = 3
    }
    char = char || " "
    return Array(size).join(char)
  }

  // function cell(content, node) {
  //   var index = Array.prototype.indexOf.call(node.parentNode.childNodes, node)
  //   var prefix = " "
  //   if (index === 0) prefix = "| "
  //   return prefix + content + " |"
  // }

  function isOnlySpace(str) {
    return !str.replace(/\s/g, "").length
  }

  var converters = {
    block: {
      filter: ["div"],
      replacement: function (innerHTML) {
        // Replacing further inline style tag in mail.
        // OWA-149
        innerHTML = innerHTML.replace(/<style\b[^<>]*>[\s\S]*?<\/style\s*>/gi, "")
        return "\n" + innerHTML + "\n"
      },
    },
    inner_content: {
      filter: ["span", "em", "i", "strong", "b", "font", "sub", "sup"],
      replacement: function (innerHTML) {
        return innerHTML
      },
    },
    strip: {
      filter: ["img", "wbr"], // wbr tag is visible on gmail links
      replacement: function () {
        return ""
      },
    },
    stripIf: {
      filter: function (node) {        
        // anchor but no text
        return node.nodeName === "A" && isOnlySpace(node.innerText)
      },
      replacement: function () {
        return ""
      },
    },
    emptyAnchor: {
      filter: function (node) {
        // anchor but no href or href ="#"
        return node.nodeName === "A" && (!node.getAttribute("href") || node.getAttribute("href") == "#")
      },
      replacement: function (content) {
        return content
      }
    },
    anchor: {
      filter: function (node) {
        return node.nodeName === "A" && node.getAttribute("href")
      },
      replacement: function (content, node) {
        return "[" + content + "](" + node.getAttribute("href") + ")"
      },
    },
    table: {
      filter: "table",
      replacement: function (content) {
        return "\n\n" + content + "\n\n"
      },
    },
    tr: {
      filter: "tr",
      replacement: function (content) {
        return "\n" + content + "\n" + fill(10, " - ")
      },
    },
    td: {
      filter: ["th", "td"],
      replacement: function (content, node) {
        var onlyWhiteSpace = !content.replace(/\s/g, "").length
        if (node.parentNode.childNodes.length > 1 && !onlyWhiteSpace) {
          return content + " |"
        } else {
          return content
        }
      },
    },
    style: {
      filter: ["style"],
      replacement: function () {
        return ""
      }
    }
  }

  // Class part
  function allConverters() {
    var arr = []
    for (var conv in converters) {
      arr.push(converters[conv])
    }
    return arr
  }

  function separateLinks(output) {
    //[-a-zA-Z0-9@:%_\+.~#?&//=]*
    var matches = output.match(/(\[(.+?)\))*/gi); // match everthing bewteen [ and )
    if (matches) {
      matches = matches.filter(function (m) {
        return !isOnlySpace(m)
      })

      var links = ""
      for (var idx = 0; idx < matches.length; idx++) {
        var parts = matches[idx].split("(")
        output = output.replace(matches[idx], parts[0])
        links += "\n" + padLeft(idx + 1, "   ") + " - " + matches[idx]
      }
      output += "\n" + links
    }
    return output
  }

  return {
    toMarkdown: function (input, linksAtBottom) {
      if (typeof linksAtBottom == "undefined") {
        linksAtBottom = true
      }

      var turndownService = new TurndownService()
      turndownService.use(gfm)

      allConverters().forEach((converter, index) => {
        turndownService.addRule("rule" + index, converter)
      })

      let output = turndownService.turndown(input)

      if (linksAtBottom) {
        output = separateLinks(output)
      }

      return output
    },
  }
}
